<template>
    <div class="card-top">
        <div class="secondary-c tw-p-6">
            <i aria-hidden="true" :class="`fa fa-${icon} tw-inline tw-text-lg`"></i>
            <h2 class="tw-inline tw-font-bold tw-text-base tw-ml-4">{{ text }}</h2>
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CardTop',
    props: ['icon', 'text']
}
</script>

<style lang="scss" scoped>
.card-top {
    border-bottom: 1px solid #e3e3e3;
}
</style>